import { Fur } from './Fur';
import { General } from './General';

export class ModalMensaje {
    titulo: string;
    mensaje: string;
    flgHtml: boolean;
    flgRegresar: boolean;
    fur: Fur;
    general: General;
    flgCaptcha: boolean;
}
